import { useQuery } from '@apollo/client/react';
import { GET_THIRD_PARTY_INFO } from 'queries/accountPreferences';

const useThirdPartyInfo = (accountId) => {
  const { error, data, loading } = useQuery(GET_THIRD_PARTY_INFO, {
    variables: { accountId },
    skip: !accountId,
    fetchPolicy: 'network-only',
  });

  const thirdParty = {
    name: data?.getAccountPreferences?.thirdPartyName,
    email: data?.getAccountPreferences?.thirdPartyEmail,
    customerOptIn: data?.getAccountPreferences?.customerOptIn,
    error,
    loading,
  };

  return thirdParty;
};

export default useThirdPartyInfo;
